
import {doDelete, doGet, doPost, doPut} from './Api';

export default class EntityService {

  static async responseGetEntity(entity=1) {
    const response = await doGet(`${process.env.REACT_APP_BASE_URL}/DetailEntity/${entity}`);
    if(response.data.success){
      return response.data;
    }else{
      throw 'Hubo un error al cargar la información';
    }
  }

  static async responseGetEntityById(id) {
   const response = await doGet(`${process.env.REACT_APP_BASE_URL}/DetailEntity/GetById/${id}`);
    if(response.data.success){
      return response.data;
    }else{
      throw 'Hubo un error al cargar la información';
    }
  }

  static async responseSaveEntity(data) {
    const response = await doPost(`${process.env.REACT_APP_BASE_URL}/DetailEntity`,data);
    if(response.data.success){
      return response.data;
    }else{
      throw 'Hubo un error al guardar';
    }
  }

  static async responseDeleteEntity(id) {
    const response = await doDelete(`${process.env.REACT_APP_BASE_URL}/DetailEntity/${id}`);
    if(response.data.success){
      return response.data;
    }else{
      console.log("error");
    }
  }

  static async responseEditEntity(data, id) {
    const response = await doPut(`${process.env.REACT_APP_BASE_URL}/DetailEntity/${id}`,data);
    if(response.data.success){
      return response.data;
    }else{
      throw 'Hubo un error al editar';
    }
  }
}
